export const researchOfferings = [
  {
    path: '/eigenleads',
    name: 'eigenLeads',
    tagline: 'Quote Release Standard',
    summary:
      'Insurance acquisition research into whether quality and regulatory controls can be made testable at the release boundary. Reachability, coverage, consent provenance, and priority checks must pass before an opportunity reaches a producer.',
    accent: 'indigo',
  },
  {
    path: '/indoc',
    name: 'inDoc',
    tagline: 'Restricted Library Investigation',
    summary:
      "Document search and retrieval research into whether an agent can plan, search, read, compare, and synthesize without exceeding enterprise access control. Local inference can keep restricted content in-perimeter; every brief retains sources and a replayable path.",
    accent: 'sky',
  },
  {
    path: '/ofms',
    name: 'OFMS',
    tagline: 'Lot Record And Certification Evidence',
    summary:
      'Regulated operations research into whether one durable lot record can serve field work, certification, quality, inventory, and buyer traceability without reconstructing compliance evidence after the event.',
    accent: 'emerald',
  },
  {
    path: '/pati',
    name: 'PATi',
    tagline: "Private Algorithmic Trading Int'l",
    summary:
      'Financial systems research into agentic automation where timing, risk gates, local inference, and forced session closure are non-negotiable. Capital moves only when the required operating state has been verified.',
    accent: 'teal',
  },
];
